// Design tokens da tela de configuração de Tarefas.
// Referência: .md/DESIGN_UIUX.md (Painel de Configurações).

export const TAREFAS_CONFIG_DESIGN = {
  root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',
  pageBody: 'pb-[120px]',

  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
  topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
  topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
  subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',

  sectionHeader: 'mt-[18px] first:mt-0 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3',
  sectionHeaderMain: 'min-w-0',
  sectionHeaderTitle: 'text-[13px] font-bold uppercase tracking-[0.06em] text-[#a1a1aa]',
  sectionHeaderSub: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',

  stack: 'flex flex-col gap-3.5',
  card: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[26px] overflow-hidden min-w-0',
  cardFlush: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0',

  field: 'min-w-0',
  label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
  hint: 'mt-[7px] text-[12px] text-[#a1a1aa] leading-[1.5]',
  input:
    'w-full box-border h-auto px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] md:text-[14px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',

  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
  ghostButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] disabled:opacity-50 disabled:cursor-not-allowed',
  iconButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButtonDanger:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#b42318] transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca]',
  iconButtonDisabled:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#d4d4d8] cursor-not-allowed',
  link: 'text-[13px] font-semibold text-[#6d28d9] transition-colors hover:text-[#5b21b6] hover:underline',

  badge: 'inline-flex items-center gap-1.5 px-2.5 py-[3px] rounded-md text-[12px] font-semibold whitespace-nowrap flex-shrink-0 border',
  badgeNeutral: 'bg-[#f4f4f5] text-[#71717a] border-[#e7e7ec]',
  badgeSoft: 'bg-[#ede9fe] text-[#5b21b6] border-[#ddd6fe]',

  tableWrap: 'w-full overflow-x-auto min-w-0',
  tableHeadRow: 'flex items-center px-[26px] py-3 border-b border-[#f0f0f3] bg-[#fafafb]',
  tableHead: 'text-[12px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa]',
  tableRow: 'group flex items-center px-[26px] py-3.5 border-b border-[#f0f0f3] last:border-b-0 hover:bg-[#fafafb] cursor-grab',
  tableCell: 'text-[14px] text-[#18181b]',
  tableCellMuted: 'text-[13px] text-[#71717a]',

  emptyState: 'px-2 py-10 text-center',
  emptyIcon:
    'mx-auto mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
  emptyTitle: 'text-[15px] font-semibold text-[#18181b]',
  emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm mx-auto',

  stageRow:
    'flex items-center gap-2 px-[13px] py-[11px] rounded-lg border border-[#e7e7ec] bg-white cursor-grab active:cursor-grabbing hover:border-[#d4d4d8]',
  stageIndex:
    'flex items-center justify-center w-5 h-5 rounded-full bg-[#ede9fe] text-[11px] font-bold text-[#6d28d9] flex-shrink-0',
  colorSwatch:
    'w-5 h-5 rounded-md border border-transparent transition-all flex-shrink-0',
  previewShell: 'bg-[#fafafb] border border-[#e7e7ec] rounded-[10px] p-4 flex items-center gap-1 flex-wrap',
  previewChip:
    'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[13px] font-semibold',

  dialogTitle: 'text-[15px] font-semibold text-[#18181b]',
  dialogDesc: 'text-[13px] text-[#71717a] leading-[1.5]',
  dialogFooter: 'flex justify-end gap-2.5',
};

export default TAREFAS_CONFIG_DESIGN;
